// extracted by mini-css-extract-plugin
module.exports = {"root":"Writing_root__17lrN","top":"Writing_top__1BHvP","row":"Writing_row__3mA9a","header":"Writing_header__3ctPE","text":"Writing_text__1xpRH"};